import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Locations_ds_get_task_count_by_warehouse_by_userService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { dayQualifier?: number }): 
  Promise<{ result: { TaskCount?: number, WarehouseId?: number, ModifiedSysUser?: string, CreatedSysUser?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Locations/datasources/ds_get_task_count_by_warehouse_by_user/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { dayQualifier?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { TaskCount?: number, WarehouseId?: number, ModifiedSysUser?: string, CreatedSysUser?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Locations/datasources/ds_get_task_count_by_warehouse_by_user/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { dayQualifier?: number, $keys: { WarehouseId?: number, ModifiedSysUser?: string, CreatedSysUser?: string }[] }): 
  Promise<{ result: { TaskCount?: number, WarehouseId?: number, ModifiedSysUser?: string, CreatedSysUser?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Locations/datasources/ds_get_task_count_by_warehouse_by_user/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      dayQualifier?: number    }) {
      return false;
    }
}
